/**
 * Normalize a property name by capitalizing the first letter and
 * replacing underscores with spaces.
 *
 * @param {string} input
 * @return {string}
 */
export function normalizePropName(input) {
  if (input) {
    if (input.trim() === "") {
      return "";
    }

    const firstChar = input.charAt(0).toUpperCase();
    const restOfString = input.slice(1);

    const formattedString = restOfString.replace(/_/g, " ");

    return firstChar + formattedString;
  }
}

/**
 * Get the initials from a given name.
 * This function returns the first two initials of a name.
 *
 * @param {string} name - The full name from which to extract initials.
 * @return {string} The initials extracted from the name.
 */
export function getInitials(name) {
  if (name) {
    if (name.trim() === "") {
      return "";
    }

    const firstChar = name.charAt(0).toUpperCase();
    const secondChar = name.charAt(1) ? name.charAt(1) : "";

    return firstChar + secondChar;
  }
}

/**
 * Checks if two arrays are equal.
 *
 * @param {Array} arr1 - The first array.
 * @param {Array} arr2 - The second array.
 * @return {boolean} True if the arrays are equal, false otherwise.
 */
export const equalArrays = (arr1, arr2) => {
  return (
    arr1.length === arr2.length && arr1.every((item) => arr2.includes(item))
  );
};
